import PropTypes from 'prop-types';
import { Breadcrumbs } from '@bwoty-web/ui-kit';

const ComboSummaryBreadcrumbs = ({ breadcrumbCruiseDetailsLabel, cruiseDetailsLink, header }) => (
  <Breadcrumbs
    className="iw-combo-summary__breadcrumbs"
    links={[
      {
        name: breadcrumbCruiseDetailsLabel,
        uri: cruiseDetailsLink,
        target: null,
      },
      {
        name: header,
        uri: window.location.href,
        target: null,
      },
    ]}
  />
);

ComboSummaryBreadcrumbs.propTypes = {
  breadcrumbCruiseDetailsLabel: PropTypes.string.isRequired,
  cruiseDetailsLink: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
};

export default ComboSummaryBreadcrumbs;
